// extracted by mini-css-extract-plugin
export var labelWrapper = "_gc-0";